export const DirectBuyerAdvantages = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4 text-gray-900">
            Why Selling to a Direct Buyer Makes FSBO Easy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            FSBO works best when you're selling to experienced investors who understand apartment buildings and can move quickly
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-close-circle-line text-3xl text-red-600"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              FSBO to Retail Buyers (Difficult)
            </h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-3">
                <i className="ri-arrow-right-s-line text-red-600 flex-shrink-0 mt-1"></i>
                <span>Buyers need extensive education about commercial real estate</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-arrow-right-s-line text-red-600 flex-shrink-0 mt-1"></i>
                <span>Financing is complicated and often falls through</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-arrow-right-s-line text-red-600 flex-shrink-0 mt-1"></i>
                <span>Buyers get cold feet during due diligence</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-arrow-right-s-line text-red-600 flex-shrink-0 mt-1"></i>
                <span>You handle all marketing, showings, and negotiations</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-arrow-right-s-line text-red-600 flex-shrink-0 mt-1"></i>
                <span>Process takes 6-12 months with high failure rate</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-arrow-right-s-line text-red-600 flex-shrink-0 mt-1"></i>
                <span>Buyers demand extensive repairs and concessions</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-teal-500">
            <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-checkbox-circle-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              FSBO to Direct Investor (Easy)
            </h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 flex-shrink-0 mt-1"></i>
                <span>Investor already understands apartment building operations</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 flex-shrink-0 mt-1"></i>
                <span>Cash purchase or pre-arranged financing that closes reliably</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 flex-shrink-0 mt-1"></i>
                <span>Investor expects normal wear and tear, no surprises</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 flex-shrink-0 mt-1"></i>
                <span>Single conversation leads to offer, minimal marketing needed</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 flex-shrink-0 mt-1"></i>
                <span>Close in 2-4 weeks with high certainty</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 flex-shrink-0 mt-1"></i>
                <span>Investor buys AS IS, no repair demands</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h3 className="text-2xl font-bold mb-8 text-gray-900 text-center">
            What Makes Us the Ideal Direct Buyer for Your FSBO Sale
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-funds-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Cash Ready</h4>
                <p className="text-gray-700 text-sm">
                  We have capital ready to deploy and don't need to wait for bank approvals or financing contingencies.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-speed-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Fast Decisions</h4>
                <p className="text-gray-700 text-sm">
                  We can evaluate your property and make an offer within 48 hours of our initial conversation.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">AS IS Purchase</h4>
                <p className="text-gray-700 text-sm">
                  We buy properties in their current condition without requiring repairs or improvements.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-user-smile-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Tenant Friendly</h4>
                <p className="text-gray-700 text-sm">
                  We respect your tenants and minimize disruption during the evaluation and closing process.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Experienced Team</h4>
                <p className="text-gray-700 text-sm">
                  We've purchased hundreds of apartment buildings and understand all aspects of the transaction.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-hand-heart-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Flexible Terms</h4>
                <p className="text-gray-700 text-sm">
                  We can structure deals with seller financing, leaseback options, or other creative solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 relative">
          <img
            src="https://public.readdy.ai/ai/img_res/4c8141086d1faa69726fdb936ac02a9f.jpg"
            alt="Direct buyer investment team for apartment building purchases"
            className="w-full h-96 rounded-xl shadow-xl object-cover"
          />
        </div>
      </div>
    </section>
  );
};